import { FormAtylBase } from '../../form-atyl-base'

export class AtylCheckbox extends FormAtylBase<string> {
	controlType = 'checkbox';
	type: string
	options: string[] = [];

	constructor(options: {} = {}) {
		super(options)
		this.type = options['type'] || []
		this.options = options['options'] || []
	}
}
